module.exports = __webpack_public_path__ + "img/208.807451c8.jpg";